// Number & date formatters used across every screen.
export const fmtCurrency = (n, digits = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  return sign + "$" + abs.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtCurrencyK = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e6) return `${n < 0 ? "-" : ""}$${(Math.abs(n) / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${n < 0 ? "-" : ""}$${Math.round(Math.abs(n) / 1e3)}K`;
  return `${n < 0 ? "-" : ""}$${Math.round(Math.abs(n))}`;
};

export const fmtPct = (n, digits = 1) =>
  n === null || n === undefined || isNaN(n) ? "—" : `${n.toFixed(digits)}%`;

export const fmtInt = (n) => (n === null || n === undefined ? "—" : n.toLocaleString("en-US"));

export const fmtDate = (s) => (s ? String(s).slice(0, 10) : "—");

// 2026-03-01 (Dave) — Scenario History timestamps show both date + time.
// 2026-03-05 (Dave) — App-wide default timezone pinned to America/Chicago
// so all timestamp displays render in US Central time regardless of the
// viewer's browser locale.
export const APP_TIME_ZONE = "America/Chicago";

// Format: `mm/dd/yyyy; h:MM AM/PM` in America/Chicago.
export const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return "—";
  // Use Intl.DateTimeFormat with America/Chicago so the mm/dd/yyyy split
  // matches the same wall-clock hour we render for the time portion.
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: APP_TIME_ZONE,
    year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(d).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  const time = d.toLocaleTimeString("en-US", {
    timeZone: APP_TIME_ZONE,
    hour: "numeric",
    minute: "2-digit",
  });
  return `${parts.month}/${parts.day}/${parts.year}; ${time}`;
};
